var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.turnover_group)?_c('span',{staticClass:"turnover-group-info"},[_vm._v("\n  "+_vm._s(_vm.turnover_group.title)+"\n  "),_c('i',{staticClass:"fi-info turnover-group-info--info",attrs:{"title":_vm.turnover_group.description}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }